import styled from 'styled-components';
import { truncate } from 'utils/styles';

export const Checklist = styled.div``;

export const ChecklistItems = styled.div`
    align-items: stretch;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    height: 100%;
    margin-top: 1.2rem;
    width: 100%;
`;
export const ChecklistItem = styled.div`
    align-items: flex-start;
    color: #8f8f8f;
    display: flex;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1.4;
    gap: 1.2rem;
    position: relative;

    .icon {
        align-items: center;
        background: #f7f9fb;
        border: 2px solid #dfe2e9;
        border-radius: 50%;
        cursor: not-allowed;
        display: flex;
        flex: 0 0 2.4rem;
        height: 2.4rem;
        justify-content: center;
        position: relative;
    }
    .icon::before {
        border-radius: 50%;
        content: '';
        display: none;
    }

    .text {
        line-height: 1.4;
        padding-top: 0.25rem;
        /* ${truncate(1, 1.4)} */
    }

    .numb {
        color: #8f8f8f;
        flex: 0 0 auto;
        margin-left: auto;
        padding-top: 0.25rem;
    }

    &.checked {
        color: ${({ theme }) => theme.colors.darkBlue};

        .icon {
            background: transparent
                linear-gradient(
                    89deg,
                    ${({ theme }) => theme.colors.energyBlue} 0%,
                    ${({ theme }) => theme.colors.deepBlue} 100%
                );
            border-color: ${({ theme }) => theme.colors.energyBlue};
            color: ${({ theme }) => theme.colors.white};
        }
        .icon::before {
            background: transparent;
            content: '\f00c';
            font-family: 'Font Awesome 5 Pro';
            font-size: 1.2rem;
            font-weight: 700;
            display: block;
            transform: translate(0, 1px);
        }
    }

    &.started {
        color: ${({ theme }) => theme.colors.darkBlue};

        .icon {
            border-color: ${({ theme }) => theme.colors.energyBlue};
        }
        .icon::before {
            background: transparent
                linear-gradient(
                    89deg,
                    ${({ theme }) => theme.colors.energyBlue} 0%,
                    ${({ theme }) => theme.colors.deepBlue} 100%
                );
            display: block;
            height: 1.2rem;
            transform: translate(0, 0);
            width: 1.2rem;
        }
    }
`;

export const ChecklistTitle = styled.div`
    strong {
        color: ${({ theme }) => theme.colors.deepBlue};
    }
`;
